import BeveledBoxSvg517x660 from './BeveledBoxSvg517x660';

export default BeveledBoxSvg517x660;
export { BeveledBoxSvg517x660 };
